export const AUTH_FAILED = "AUTH_FAILED";
export const AUTH_PASSED = "AUTH_PASSED";
export const WEDDING_PASSED = "WEDDING_PASSED";
export const WEDDING_FAILED = "WEDDING_FAILED";
export const VERIFYUSER = "VERIFYUSER";
export const NOTES_FAILED = "NOTES_FAILED";
export const NOTES_SUCCESS = "NOTES_SUCCESS";
export const URL_FAILED = "URL_FAILED";
